export default __webpack_public_path__ + "static/SR USA - California Proposition 65 - Statement-5aa0cbf333606bf05003d9a6138badde.pdf";